import React, { useEffect, useState } from 'react';
import RepoSettings from './settings/RepoSettings/RepoSettings';
import ImageSettings from './settings/ImageSettings/ImageSettings';
import DeploymentSettings from './settings/DeploymentSettings/DeploymentSettings';
import CodeSettings from './settings/CodeSetting/CodeSettings';
import PipeLineSettings from './settings/PipeLineSettings/PipelineSettings';
import EndpointsSettings from './settings/EndpointsSettings/Endpoints';
import DBSettings from './settings/DBSettings/DBSettings' ;

import "./Container.css"
import { Back } from '../../../../../components/back/Back';

const Container = ({ serviceName, submit, projectId, back, data, setData }) => {
    const [currentPage, setCurrentPage] = useState("repo")
    const [direction, setDirection] = useState("forward")

    
    const goBack = (page)=>{
        setCurrentPage(page);
        setDirection("back");
    }

    const goFoward = (page)=>{
        setCurrentPage(page)
        setDirection("forward")
    }

    useEffect(()=> {
        setData(Object.keys(data).length > 0 ? {...data, name: serviceName} : {
            "name": serviceName,
            "project": projectId,
            "service_type": "ContainerService",
            "version": "0.1",
            "repo": {},
            "image_registry": {},
            "image_type": "docker",
            "infrastructure": {},
            "pipeline": {},
            "endpoints": [],
            "language": "",
            "framework": {},
            "test": {},
            "db": {}
        })
    }, [])


    return (
        <div className='container-service'>
        { Object.keys(data).length > 0 &&
        <form className="new-service-form glassmorphism">
            {currentPage === "repo" && <RepoSettings projectId={projectId} data={data.repo} serviceName={serviceName} setRepo={(repo)=>{setData({...data, repo:repo})}} next={()=>{setCurrentPage("image")}} back={back}/>}
            {currentPage === "image" && <ImageSettings data={data.image_registry} serviceName={serviceName} projectId={projectId} setImage={(image)=>{setData({...data, image_registry:image})}} next={()=>{goFoward("deployment")}} back={()=>{setCurrentPage("repo")}}/>}
            {currentPage === "deployment" && <DeploymentSettings data={data.infrastructure} serviceName={serviceName} projectId={projectId} setDeployment={(deployment)=>{setData({...data, infrastructure:deployment})}} next={()=>{goFoward("code")}} back={()=>{setCurrentPage("image")}} direction={direction}/>}
            {currentPage === "code" && <CodeSettings code={{language: data.language, framework: data.framework}} setCode={(language, framework)=>{setData({...data, language: language, framework: framework})}} direction={direction} next={()=>{setCurrentPage("pipeline")}} back={()=>{goBack("deployment")}} serviceName={serviceName}/>}
            {currentPage === "pipeline" && <PipeLineSettings data={data.pipeline} projectId={projectId} serviceName={serviceName} setPipeline={(pipeline)=>{setData({...data, pipeline:pipeline})}} next={()=>{setCurrentPage("endpoints")}} back={()=>{goBack("code")}}/>}
            {currentPage === "endpoints" && <EndpointsSettings data={data.endpoints} setEndpoints={(endpoints)=>{setData({...data, endpoints:endpoints})}} next={()=>{setCurrentPage("db")}} serviceName={serviceName} back={()=>{setCurrentPage("pipeline")}}/>}
            {currentPage === "db" && <DBSettings dbSetting={data.db} setDb={(db)=>{setData({...data, db:db})}} next={()=>{setCurrentPage("end")}} back={()=>{setCurrentPage("endpoints")}} serviceName={serviceName}/>}
            {currentPage === "end" && (<div>
                    <Back back={()=>setCurrentPage("db")}/>
                    <button className='create' onClick={()=>{submit(data)}}>Create Microservice</button>
                    </div>)}
        </form>}
        </div>
    );
};

export default Container;